module.exports = __webpack_public_path__ + "img/add.bcdbda3e.png";